import { render, staticRenderFns } from "./EventArticlesOverTime.vue?vue&type=template&id=73a5b48c&scoped=true"
import script from "./EventArticlesOverTime.vue?vue&type=script&lang=js"
export * from "./EventArticlesOverTime.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73a5b48c",
  null
  
)

export default component.exports